import { useEffect } from "react";
import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import { AlphadigiTypeEnum } from "../../../constants/readers-model";
import { getNestedValue, setNestedValue } from "../../../utils/object";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

export function PartialFormAlphadigi({ configuration, setConfiguration, setEditablePort, ...props }) {

   useEffect(() => {
      setEditablePort(configuration?.type === AlphadigiTypeEnum.FACIAL);
      if (!configuration) {
         setConfiguration({
            type: AlphadigiTypeEnum.LPR,
            displayLed: {},
         });
      }
   }, []);

   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      if (field === 'type') {
         setEditablePort(value !== AlphadigiTypeEnum.LPR);
      }
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <>
         <div className="w-full grid grid-cols-2 gap-2.5">
            {configuration?.type !== AlphadigiTypeEnum.LPR && (
               <>
                  <Input
                     name="user"
                     id="user"
                     labelText="Usuário"
                     value={configuration?.user}
                     onChange={({ target }) => onChange('user', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="password"
                     id="password"
                     type="password"
                     labelText="Senha"
                     value={configuration?.password}
                     onChange={({ target }) => onChange('password', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
               </>
            )}
            <Select
               labelText="Tipo"
               value={configuration?.type}
               onChange={({ target }) => onChange('type', target.value)}
               disabled={props.type === "consulta"}
               required={true}
               options={[
                  { value: AlphadigiTypeEnum.LPR, text: 'LPR' },
                  { value: AlphadigiTypeEnum.FACIAL, text: 'Facial' },
               ]}
            />
            <Input
               name="eventTimeout"
               id="eventTimeout"
               type="number"
               labelText="Timeout de Evento"
               tooltipVisible={true}
               tooltipText="Eventos registrados após esse tempo em segundos, serão ignorados. (0 = ignorar verificação)"
               value={configuration?.eventTimeout}
               onChange={({ target }) => onChange('eventTimeout', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
         </div>
         {configuration?.type === AlphadigiTypeEnum.FACIAL && (
            <div className="w-full grid grid-cols-2 gap-2.5">
               <Input
                  name="confidence"
                  id="confidence"
                  type="number"
                  labelText="Confidence (%)"
                  tooltipVisible={true}
                  tooltipText="(0 = ignorar)"
                  value={configuration?.confidence}
                  onChange={({ target }) => onChange('confidence', target.value)}
                  disabled={props.type === "consulta"}
                  required={true}
               />
               <ToggleButton
                  style={{ width: 'fit-content', paddingTop: '15px' }}
                  label={`Leitora com Validação de Máscara`}
                  onChange={(e) => onChange('userMaskValidation', e.target.checked)}
                  selected={configuration?.userMaskValidation}
               />
            </div>
         )}
         {configuration?.type === AlphadigiTypeEnum.LPR && (
            <>
               <h3 className="bordered muted-md">Display LED</h3>
               <div className="w-full grid grid-cols-2 gap-2.5">
                  <Input
                     name="okMessageLine1"
                     id="okMessageLine1"
                     labelText="Mensagem de OK Linha 1"
                     value={configuration?.displayLed?.okMessageLine1}
                     onChange={({ target }) => onChange('displayLed.okMessageLine1', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="okMessageLine2"
                     id="okMessageLine2"
                     labelText="Mensagem de OK Linha 2"
                     value={configuration?.displayLed?.okMessageLine2}
                     onChange={({ target }) => onChange('displayLed.okMessageLine2', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="errorMessageLine1"
                     id="errorMessageLine1"
                     labelText="Mensagem de Erro Linha 1"
                     value={configuration?.displayLed?.errorMessageLine1}
                     onChange={({ target }) => onChange('displayLed.errorMessageLine1', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="errorMessageLine2"
                     id="errorMessageLine2"
                     labelText="Mensagem de Erro Linha 2"
                     value={configuration?.displayLed?.errorMessageLine2}
                     onChange={({ target }) => onChange('displayLed.errorMessageLine2', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="time"
                     id="time"
                     type="number"
                     labelText="Tempo"
                     value={configuration?.displayLed?.time}
                     onChange={({ target }) => onChange('displayLed.time', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
                  <Input
                     name="restMessage"
                     id="restMessage"
                     labelText="Mensagem de Restrição"
                     value={configuration?.displayLed?.restMessage}
                     onChange={({ target }) => onChange('displayLed.restMessage', target.value)}
                     disabled={props.type === "consulta"}
                     required={true}
                  />
               </div>
            </>
         )}
      </>
   )
}